import React from 'react';

import ConsumableEdit from '@components/shared/consumables/ConsumableEdit';
import { useMerchant } from '@contexts/admin/MerchantContext';
import useAdminConsumableService from '@hooks/admin/consumables/useAdminConsumableService';
import { useParams } from 'react-router-dom';

export default function AdminConsumableEdit() {
  const { id } = useParams();
  const consumableService = useAdminConsumableService();
  const { volumeUnit } = useMerchant();

  return (
    <ConsumableEdit
      loadConsumable={consumableService.get}
      createConsumable={consumableService.create}
      updateConsumable={consumableService.update}
      volumeUnit={volumeUnit}
      consumableId={id}
    />
  );
}
